import { dayjs } from "../dayjs.utils";

import { IDateRange } from "../../models";
import { DATE_FORMAT_YMD } from "../../constants";

/** A range ending today and reaching `days` back, inclusive of both ends. */
export const toRecentRange = (days: number): IDateRange => {
  const today = dayjs();

  return {
    from: today.subtract(days, "days").format(DATE_FORMAT_YMD),
    to: today.format(DATE_FORMAT_YMD),
  };
};

export const toTodayRange = (): IDateRange => {
  const today = dayjs();

  return {
    from: today.format(DATE_FORMAT_YMD),
    to: today.format(DATE_FORMAT_YMD),
  };
};

/**
 * The one mistake a period filter can make: an end before its start. ДПС would
 * answer such a query with an empty period rather than an error, so it is
 * caught in the form. `YYYY-MM-DD` sorts as text, hence the plain comparison;
 * an open end is not a mistake, it is simply no bound.
 */
export const isOrderedRange = ({ from, to }: IDateRange): boolean =>
  !from || !to || from <= to;

/**
 * Caps how far apart `from`/`to` may be. Unlike `isOrderedRange`, a missing
 * bound does NOT pass here: an open end is an unbounded query, exactly what
 * this guards against. See `MAX_REGISTER_RANGE_DAYS`.
 */
export const isWithinMaxRange = (
  { from, to }: IDateRange,
  maxDays: number,
): boolean =>
  Boolean(from) && Boolean(to) && dayjs(to).diff(dayjs(from), "day") <= maxDays;
